// BotsHub.jsx — Phase 1 nav consolidation.
//
// Unifies three previously-separate top-level routes (Bot Library, AI Bots,
// Text Bots) under a single /bots page with tabs. The underlying page
// components are reused as-is; this file only owns tab state and dispatch.
//
// Detail routes (/bots/:id, /aibots/:id, /text-bots/:id) are unchanged.

import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BookOpen, Bot, MessageSquare } from 'lucide-react';
import Bots from './Bots.jsx';
import AIBots from './AIBots.jsx';
import TextBots from './TextBots.jsx';

const TABS = [
  { id: 'library',  label: 'Library',   icon: BookOpen,      Component: Bots,     description: 'Trained bot library — voice + corpus stats, shareability.' },
  { id: 'ai',       label: 'AI Bots',   icon: Bot,           Component: AIBots,   description: 'Programmable outbound SMS + voice agents.' },
  { id: 'text',     label: 'Text Bots', icon: MessageSquare, Component: TextBots, description: 'SMS-only autoresponders with scripts + examples.' },
];

export default function BotsHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initial = TABS.find((t) => t.id === searchParams.get('tab'))?.id || 'library';
  const [active, setActive] = useState(initial);

  function selectTab(id) {
    setActive(id);
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: true });
  }

  const ActiveComponent = TABS.find((t) => t.id === active)?.Component || Bots;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-1 border-b border-white/10">
        {TABS.map((t) => {
          const Icon = t.icon;
          const isActive = t.id === active;
          return (
            <button
              key={t.id}
              onClick={() => selectTab(t.id)}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${
                isActive
                  ? 'border-civix-purple text-white'
                  : 'border-transparent text-white/60 hover:text-white/90'
              }`}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </button>
          );
        })}
      </div>
      <ActiveComponent />
    </div>
  );
}
